(function () {
  let slideIndex = 1;
  let isMobile = window.innerWidth <= 768;
  const prevButton = document.getElementById("bannerPrev");
  const nextButton = document.getElementById("bannerNext");
  let slideInterval;

  function handleResize() {
    let wasMobile = isMobile;
    isMobile = window.innerWidth <= 768;

    if (isMobile !== wasMobile) {
      //switched modes, hide all relevant slides
      hideSlides();
      showSlides(slideIndex);
    }
  }

  function plusSlides(n, isNext) {
    showSlides((slideIndex += n), isNext);
  }

  function currentSlide(n) {
    showSlides((slideIndex = n));
  }

  function hideSlides() {
    let slides = isMobile
      ? document.getElementsByClassName("mySlides")
      : document.getElementsByClassName("mobile-slide");

    for (let i = 0; i < slides.length; i++) {
      if (slides[i].style.display === "block") { // Check if slide is currently visible
        slides[i].style.animation = "fadeOut 0.8s ease-out-in"; // Apply animation inline

        setTimeout(() => {
          slides[i].style.display = "none"; // Hide after animation completes
          slides[i].style.animation = ""; // Reset animation property
        }, 800); // Match animation duration
      }
    }
}

  function showSlides(n, isNext) {
    let i;
    let slides = isMobile
      ? document.getElementsByClassName("mobile-slide")
      : document.getElementsByClassName("mySlides");
    //let dots = document.getElementsByClassName("dot");

    if (n > slides.length) {
      slideIndex = 1;
    }
    if (n < 1) {
      slideIndex = slides.length;
    }

    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none"; // Hide all slides
    }
    // for (i = 0; i < dots.length; i++) {
    ///  dots[i].className = dots[i].className.replace(" current-slide", "");
    //}

    // Apply the correct animation based on the direction
    if (isNext) {
      slides[slideIndex - 1].style.animation = "fadeInRight 0.8s ease-in-out";
    } else {
      slides[slideIndex - 1].style.animation = "fadeInLeft 0.8s ease-in-out";
    }
    slides[slideIndex - 1].style.display = "block"; // Show the active slide
    //dots[slideIndex-1].className += " current-slide";
  }

  showSlides(slideIndex);

  if (isMobile) {
    hideSlides();
  }

  function startSlideInterval() {
  slideInterval = setInterval(function () {
    plusSlides(1, true);
  }, 7000);
}

function resetSlideInterval() {
  clearInterval(slideInterval);  
  startSlideInterval();          
}

// Initialize the slideshow rotation
startSlideInterval();

prevButton.addEventListener("click", function () {
  plusSlides(-1, false);
  resetSlideInterval();  
});

nextButton.addEventListener("click", function () {
  plusSlides(1, true);
  resetSlideInterval();  
});

  window.addEventListener("resize", function () {
    handleResize();
  });
})();
